<template>
  <div class="back">
    <div class="consulting-title">
      <span @click="$router.back()" v-show="icon" role="img" aria-label="left" class="anticon anticon-left back" tabindex="-1">
        <svg focusable="false" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896">
          <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg
      ></span>
      <span class="text">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String },
    icon: { type: false, default: false },
  },
};
</script>

<style lang="scss" scoped>
.consulting-title {
  box-shadow: 0 2px 4px #eaeaea80;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  font-size: 24px;
  color: #000;
  letter-spacing: 1.92px;
  line-height: 24px;
  .back {
    margin-right: 30px;
  }
  .back:hover {
    cursor: pointer;
    color: #3562f4;
  }
}
</style>
